import { FEE_NAME, DEFAULT_AMOUNT, STATUS, DISPLAY_ORDER, FEE_CODE } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { FormInput } from "@/components";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Fee Type",
    moduleRoute: `${routes.masterData}/${routes.ocpFeeTypes}`,
    schema,
    defaultValues: { [FEE_CODE]: "", [FEE_NAME]: "", [DEFAULT_AMOUNT]: "", [STATUS]: true, [DISPLAY_ORDER]: "" },
    nameFieldKey: FEE_NAME,
    queryKeyToInvalidate: "fee-types",
    module: "fee-types",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  const { form, requiredFields } = addEditHook;
  const { errors } = form.formState;

  const customFields = (
    <>
      <FormInput
        name={FEE_CODE}
        control={form.control}
        label="Fee Code"
        placeholder="Please enter"
        error={errors[FEE_CODE]?.message}
        isRequired={requiredFields.includes(FEE_CODE)}
      />
      <FormInput
        name={DEFAULT_AMOUNT}
        control={form.control}
        label="Amount"
        placeholder="Please enter"
        error={errors[DEFAULT_AMOUNT]?.message}
        isRequired={requiredFields.includes(DEFAULT_AMOUNT)}
        variant="integer"
        startIcon="$"
      />
      <FormInput
        name={DISPLAY_ORDER}
        control={form.control}
        label="Display Order"
        placeholder="Please enter"
        error={errors[DISPLAY_ORDER]?.message}
        isRequired={requiredFields.includes(DISPLAY_ORDER)}
        variant="integer"
      />
    </>
  )

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Fee Name"
      customFields={customFields}
      hideDesc
    />
  );
};

export default AddEdit;
